<nz-select nzPlaceHolder="Seleziona Lingua" class="user-menu-language-select ps-w-100"
  [ngModel]="tsvc.currentLanguage.value" (ngModelChange)="tsvc.switchLanguage($event)">
  <nz-option *ngFor="let lan of tsvc.availableLanguages" [nzValue]="lan.languageId"
    [nzLabel]="lan.languageName">
    {{lan.languageName}}

  </nz-option>
</nz-select>